<template>
	<div class="myfooter">
		myfooter
	</div>
</template>

<script>
	export default{
		name: 'myfooter',
	}
</script>

<style>
</style>
